import { getFunctions, type Functions } from 'firebase/functions';
import { getAppConfig } from '@/config/appConfig.js';
import { firebaseApp } from './firebaseApp.js';

export const getFirebaseFunctions = (): Functions | undefined => {
  if (!firebaseApp) return undefined;
  try {
    const functions = getFunctions(firebaseApp, getAppConfig().functionsRegion);
    return functions;
  } catch {
    return undefined;
  }
};

export const firebaseFunctions = getFirebaseFunctions();
